<template>
  <div class="modalWrapper">
    <div class="modal">
      <div class="modal-hd">
        <div class="modal-hd-title">
          {{ title }}
        </div>
        <div class="modal-hd-close" @click="toggleModal">
          x
        </div>
      </div>
      <div class="modal-bd">
        <slot></slot>
      </div>
      <div class="modal-ft">
        <button class="formButton" @click="emitPrimaryAction">
          {{ primaryButtonTitle }}
        </button>
        <button class="formButton formButton_cancel" @click="toggleModal">
          Cancel
        </button>
      </div>
    </div>
    <div class="modal-backdrop" @click="toggleModal"></div>
  </div>
</template>

<style lang="scss" scoped>
.modal {
  background: $COLOR_WHITE;
  border-radius: 14px;
  box-shadow: 0 3px 12px 0 rgba(0, 0, 0, 0.2);
  color: $COLOR_GREY;
  left: 50%;
  padding: 50px 0 0;
  position: fixed;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 76%;
  z-index: 5;
}

.modal-backdrop {
  background: rgba(242, 242, 242, 0.95);
  height: 100vh;
  left: 0;
  position: fixed;
  top: 0;
  width: 100vw;
  z-index: 4;
}

.modal-hd {
  border-radius: 14px 14px 0 0;
  position: relative;
}

.modal-hd-title {
  color: $COLOR_BRAND2;
  font-family: 'Montserrat', sans-serif;
  font-size: 22px;
  padding: 0 50px;
  text-transform: capitalize;
}

.modal-hd-close {
  align-items: center;
  background: #ffffff;
  border-radius: 50%;
  color: #666667;
  display: flex;
  font-size: 20px;
  height: 40px;
  justify-content: center;
  position: absolute;
  right: 0px;
  top: -50px;
  width: 40px;
}

.modal-bd {
  font-size: 32px;
  min-height: 0;
  padding: 0;
}

.modal-ft {
  padding: 50px 0 30px;
  margin: 0 auto;
  width: 82%;
}

.formButton + .formButton {
  margin-top: 20px;
}

.formButton_cancel {
  background: $COLOR_DARK_GREY;
  border-color: $COLOR_DARK_GREY;
}
</style>

<script>
export default {
  name: 'modal',
  components: {},
  props: {
    title: {
      type: String,
      default: 'Modal Title',
    },
    primaryButtonTitle: {
      type: String,
      default: 'Confirm',
    },
  },
  methods: {
    toggleModal() {
      this.$emit('toggleModal');
    },
    emitPrimaryAction() {
      this.$emit('primaryAction');
    },
  },
};
</script>
